<template>
  <div class="user-cta">
    <Icon name="grClockForward" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ title }}</h4>
<!--       <h5 class="user-cta__subtitle" v-if="Boolean(canPurchaseDuringStay) === false">
        {{ $t('pages.checkins.no_photo_in_stay_subtitle') }}
      </h5>-->
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CtaCantSeePhotosInStay",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['mediaNotVisibleText']),
    title() {
      return this.mediaNotVisibleText || this.$t('pages.checkins.cant_see_photos_in_stay_title')
    }
  },
}
</script>


<style scoped>

</style>